import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import {
  BarChart3, Building2, ChefHat, ClipboardList, Filter, LayoutDashboard, LayoutGrid, LogOut, Mail, Monitor, Moon,
  Receipt, Settings, Sun, Timer, Users, Utensils, UserCog, XCircle,
} from "lucide-react";

export function Nav({ view, setView, wsLive, wsPulse, draftsCount = 0 }) {
  const { user, logout } = useAuth();
  const { theme, override, setOverride } = useTheme();
  const isManager = user?.role === "manager";
  const isCashier = user?.role === "cashier";
  const allowed = (mod) => isManager || (isCashier && (user?.modules || []).includes(mod));
  const links = (isManager || isCashier)
    ? [
        ["pos", "Point of Sale", Utensils, "pos"],
        ["drafts", "Draft Tickets", ClipboardList, "pos"],
        ["kitchen", "Kitchen Display", ChefHat, "kitchen"],
        ["manager", "Manager View", LayoutDashboard, "manager"],
        ["customers", "Customers", Users, "__manager_only__"],
        ["menu", "Menu Builder", Settings, "menu"],
        ["categories", "Categories", Filter, "categories"],
        ["online-categories", "Online Categories", LayoutGrid, "__manager_only__"],
        ["stations", "Station Admin", Building2, "stations"],
        ["display", "Customer Display", Monitor, "kitchen"],
        ["users", "User Management", UserCog, "__manager_only__"],
        ["settings", "Bill Settings", Receipt, "__manager_only__"],
        ["smtp", "SMTP API", Mail, "__manager_only__"],
        ["summary", "Daily Summary", Timer, "summary"],
        ["completed", "Completed Orders", Receipt, "summary"],
        ["refunds", "Refund Ledger", XCircle, "__manager_only__"],
        ["reports", "Reports", BarChart3, "reports"],
      ].filter(([, , , mod]) => (mod === "__manager_only__" ? isManager : allowed(mod)))
    : [
        ["kitchen", "My Kitchen", ChefHat, "kitchen"],
        ["reports", "My Reports", BarChart3, "reports"],
      ];
  const initials = (user?.name || user?.email || "?").split(/[\s@.]/).filter(Boolean).slice(0, 2).map((s) => s[0]?.toUpperCase()).join("");
  return (
    <aside className="nav">
      <div className="brand">
        <img src="/logo.jpg" alt="Shimla QoH Food Court" className="brand-logo" />
        <div>Shimla QoH<small>FOOD COURT · POS</small></div>
      </div>
      <div className="nav-links">
        {links.map(([id, label, Icon]) => (
          <button data-testid={`nav-${id}-button`} className={view === id ? "active" : ""} onClick={() => setView(id)} key={id}>
            <Icon size={18} />{label}
            {id === "drafts" && draftsCount > 0 && (
              <span className="nav-badge" data-testid="nav-drafts-badge">{draftsCount}</span>
            )}
          </button>
        ))}
      </div>
      <div data-testid="ws-status" className={`ws-status ${wsLive ? "on" : "off"}`}>
        <i key={wsPulse} />{wsLive ? "Live sync" : "Reconnecting…"}
      </div>
      <div className="theme-toggle-row" data-testid="theme-toggle-row">
        <button
          data-testid="theme-light-button"
          className={`theme-btn ${theme === "light" ? "on" : ""}`}
          onClick={() => setOverride(override === "light" ? null : "light")}
          title={override === "light" ? "Auto (follow local time)" : "Force light"}
        ><Sun size={13} /></button>
        <button
          data-testid="theme-dark-button"
          className={`theme-btn ${theme === "dark" ? "on" : ""}`}
          onClick={() => setOverride(override === "dark" ? null : "dark")}
          title={override === "dark" ? "Auto (follow local time)" : "Force dark"}
        ><Moon size={13} /></button>
        <small className="theme-hint">{override ? "Manual" : "Auto"}</small>
      </div>
      <div className="user">
        <div className="avatar">{initials || "KP"}</div>
        <div>
          <b>{user?.name || "—"}</b>
          <small>{user?.role === "manager" ? "Manager · Online" : user?.role === "cashier" ? "Cashier · Online" : `Station · ${user?.name || ""}`}</small>
        </div>
        <button data-testid="logout-button" className="logout-btn" onClick={logout} title="Sign out"><LogOut size={15} /></button>
      </div>
    </aside>
  );
}
